import { Box, BoxProps } from "@primer/react";
import styles from "./place-holder.module.css";

interface IPlaceHolderProps extends BoxProps {
    lineNumber?: number
}
const PlaceHolder = (props: IPlaceHolderProps) => {
    const line_number = props.lineNumber || 3;
    let lines = [];
    for (let index = 0; index < line_number; index++) {
        lines.push(index)
    }
    return (

        <Box {...props}>
            {lines.map(x => {
                return (
                    <Box key={x} className={styles.load_line} style={{ width: `${(x === 1 ? 100 : 50 + Math.random() * 50)}%` }}>
                        <div className={styles.activity}></div>
                    </Box>
                )
            })}
        </Box>

    )
}
export { PlaceHolder };

